import { Modal, message,Select,Typography,Space,Row,Divider} from "antd";
import { useEffect, useRef, useState } from "react";
import CenterService from "../../../services/CenterService";
import "./TransferUser.css"

const {Text}=Typography;
export default function TransferUser(props) {
    const {
        openModal,
        setOpenModal,
        UserTarget,
        ListCenters,
        ListInstitutes,
        setInstitute,
        viewOptions,
        SetViewOptions,
        setNeedReloadUSer,
    }=props;
    const [completeTransferUser,setCompleteTransferUser]=useState(false)
    const [centerSelected,setCenterSelected]=useState(UserTarget?.centerId)
    const [instituteSelected,setInstituteSelected]=useState(UserTarget?.centerId)
    // const {current:centerId}=useRef(UserTarget.centerId)

    const handleConfirm=()=>{
        setCompleteTransferUser(false)
        let center={
            centerId:centerSelected
        }
        if(viewOptions){
            center={
                ...center,
                instituteId: instituteSelected,
            }
        }
        else{
            center={
                ...center,
                instituteId: null,
            }
        }
        CenterService.transferToUserAnotherCenter(UserTarget.id,center)
            .then((res)=>{
            if(res.data.success){
               message.success("Se cambio correctamente")
               setNeedReloadUSer(true)
            }else{
                message.success("Ocurrio un error al cambiar")
            }      
            setCompleteTransferUser(true)
            handleOnCancel()

          });
    }

    const handleOnCancel=()=>{
        setOpenModal(false)
        setCenterSelected("")
    }

    const filterOption = (input, option) =>
    (option?.label ?? '').toLowerCase().includes(input.toLowerCase());

     const onSearch = (value) => {
    console.log('search:', value);
    };


    const handleChangeInstitute=(value)=>{
        setInstitute(value)
        setInstituteSelected(value)
        setCenterSelected(null)
    }

    useEffect(()=>{
        // setCenterSelected(UserTarget?.centerId)
        // console.log(UserTarget)
        // console.log(ListCenters)
        setCenterSelected()
        
    },[viewOptions])

    return(
    <>
        <Modal
        title={`Transferencia de Usuario`}
        open={openModal}
        onCancel={()=>{
            handleOnCancel()
        }}
        confirmLoading={completeTransferUser}
        onOk={handleConfirm}
        >
            <Row>
                <Space direction="vertical">
                    <Text>Seleccione opción para transferir</Text>
                    <Select
                    mode={"combobox"}
                    placeholder={"Seleccione una opción"}
                    onChange={(e)=>SetViewOptions(e)}
                    options={[
                        {
                            label:"Centro con instituto asignado",
                            value:true,
                        },
                        {
                            label:"Centro sin instituto asignado",
                            value:false,
                        },
                    ]}
                    >
                    </Select>
                </Space>
            </Row>
            <Divider></Divider>
            {viewOptions?(
            <Space
            direction="vertical"
            >
                <Text>Seleccione el instituto para transferir</Text>
                <Select
                className="SelectClass"
                value={instituteSelected}
                onChange={(e)=>(handleChangeInstitute(e))}
                showSearch
                placeholder="Seleccione un instituto" 
                otionFilterProp="children"
                onSearch={onSearch}
                filterOption={filterOption}
                options={ListInstitutes}
                >
                </Select>
                <Text>Seleccione el centro para transferir</Text>
                <Select className="SelectClass"
                value={centerSelected}
                onChange={(e)=>(setCenterSelected(e))}
                showSearch
                placeholder="Seleccione un centro" 
                otionFilterProp="children"
                onSearch={onSearch}
                filterOption={filterOption}
                options={ListCenters}
                >
                </Select>
            </Space>):
            (<>
                <Text>Seleccione el centro para transferir</Text>
                <Select className="SelectClass"
                value={centerSelected}
                onChange={(e)=>(setCenterSelected(e))}
                showSearch
                placeholder="Seleccione un centro" 
                otionFilterProp="children"
                onSearch={onSearch}
                filterOption={filterOption}
                options={ListCenters}
                >
                </Select>
                </>)
            }
            
        </Modal>
    </>
    );
}